module.exports = __webpack_public_path__ + "static/service-section03-img-sp-9c1e29c6a187b2af31e6fd8988cd25a9.png";